import productFaqAskHtml from './productfaqask.component.html';
import './productfaqask.component.scss';

class ProductFaqAskController {
    constructor($scope, $http, $window, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.SnackbarService = SnackbarService;

        this.productName = null;
        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            type: 'product',
            from: '',
            email: '',
            content: '',
            file: null
        };

        this.dataValidations = {
            from: () => this.userIsLoggedIn === 1 || this.data.from !== '',
            email: () => this.userIsLoggedIn === 1 || this.data.from !== '',
            content: () => this.data.content !== '',
            file: () => {
                const file = this.data.file;

                if (!file) {
                    return true;
                }

                const maxSize = 10 * 1024 * 1024; // 10 * 1024 * 1024 B = 10 MB

                const allowedExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'mp4', 'pdf', 'doc', 'docx'];

                const name = file.fileName || '';
                const ext = name.slice(name.lastIndexOf('.') + 1).toLowerCase();

                return file.fileSize <= maxSize && allowedExts.includes(ext);
            }
        };
    }

    isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }

        return true;
    }

    $onInit() {
        this.data.productId = this.productId;
    }

    save() {
        this.showAllErrors = true;

        if (!this.isValid()) return;

        this.loading = true;

        const formData = new FormData();

        formData.append('type', this.data.type);
        formData.append('product_id', this.data.productId);
        formData.append('from', this.data.from);
        formData.append('email', this.data.email);
        formData.append('content', this.data.content);

        if (this.data.file) {
            formData.append('file', this.data.file.fileFormData.get('file'));
        }

        this.$http.post('/ajax/faq/add', formData, {
            transformRequest: angular.identity,
            headers: {'Content-Type': undefined}
        }).then(
            (response) => {
                this.loading = false;

                this.$scope.$parent.$ctrl.close();

                this.SnackbarService.add(response.data.message.content, response.data.message.type, true, 3000);
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let productFaqAskComponent = {
    bindings: {
        productId: '<',
        productName: '@',
        userIsLoggedIn: '<'
    },
    template: productFaqAskHtml,
    controller: ProductFaqAskController
};

export default productFaqAskComponent;
